import React, { useEffect, useRef, useState } from "react";
import { HomeHeader } from "../../../components/headers/HomeHeader"; // adjust if needed

const HOME_HEADER_HEIGHT = 79; // match your actual HomeHeader height

export const ProactiveSeverityLitigatioinIntelligence = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const tagRef = useRef(null);
  const dropdownRef = useRef(null);
  const year = new Date().getFullYear();

  // click-away to close
  useEffect(() => {
    const onClickAway = (e) => {
      if (!menuOpen) return;
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        tagRef.current &&
        !tagRef.current.contains(e.target)
      ) {
        setMenuOpen(false);
      }
    };
    window.addEventListener("click", onClickAway);
    return () => window.removeEventListener("click", onClickAway);
  }, [menuOpen]);

  return (
    <div>
      <HomeHeader headerColor="#0D131E" textColor="#ffffff" />

      {/* Scoped styles */}
      <style>{`
        li {
          padding-top:10px;
          padding-bottom:0px;
        }

        .psli-root {
          --bg: #0a0c10;
          --panel: #0f131a;
          --panel-2: #121722;
          --text: #e6e9ef;
          --muted: #a7b0c0;
          --brand: #0b5cff;
          --brand-2: #8ab4ff;
          --ok: #1fbf75;
          --warn: #ffd166;
          --danger: #ff5d5d;
          --card-radius: 18px;
          --shadow: 0 10px 30px rgba(0,0,0,.35);
          --maxw: 1100px;
          --offset: ${HOME_HEADER_HEIGHT}px;

          color: var(--text);
          background:
            radial-gradient(1200px 800px at 10% -10%, rgba(11,92,255,.15), transparent 60%),
            radial-gradient(1200px 800px at 110% 10%, rgba(138,180,255,.1), transparent 60%),
            var(--bg);
          line-height: 1.55;
          font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji";
          text-align: left;
          letter-spacing: normal;
        }

        .psli-container { max-width: var(--maxw); margin: 0 auto; padding: 24px; }

        /* Sticky page header sits below HomeHeader */
        .psli-header {
          position: sticky;
          top: var(--offset);
          z-index: 50;
          backdrop-filter: saturate(140%) blur(10px);
          background: linear-gradient(180deg, rgba(10,12,16,.9), rgba(10,12,16,.6));
          border-bottom: 1px solid rgba(255,255,255,.06);
        }
        .psli-nav { display:flex; align-items:center; justify-content:space-between; gap:16px; }
        .psli-logo { display:flex; align-items:center; gap:12px; text-decoration:none; color:var(--text); }
        .psli-mark { width:28px; height:28px; display:grid; place-items:center; border-radius:8px; background:linear-gradient(135deg, var(--brand), #2b90ff); box-shadow: var(--shadow); }
        .psli-word { font-weight:700; letter-spacing:.2px; }

        .psli-cta { display:flex; gap:10px; }
        .psli-btn {
          --padx: 14px; --pady: 10px;
          padding: var(--pady) var(--padx);
          border-radius: 999px;
          border: 1px solid rgba(255,255,255,.12);
          color: var(--text);
          text-decoration: none;
          font-weight:600; font-size:14px;
          transition: transform .06s ease, background .2s ease, border-color .2s ease;
        }
        .psli-btn:hover { transform: translateY(-1px); }
        .psli-btn.primary { background: linear-gradient(135deg, var(--brand), #2b90ff); border-color: transparent; }
        .psli-btn.ghost { background: rgba(255,255,255,.03); }

        .psli-hero { padding: 56px 0 26px; position: relative; }
        .psli-hero h1 { font-size: clamp(34px, 3.8vw, 48px); line-height: 1.12; margin: 0 0 16px; letter-spacing: .3px; word-spacing: .4px; }
        .psli-hero p { color: var(--muted); font-size: clamp(16px, 1.7vw, 18px); max-width: 880px; }
        .psli-tag {
          display:inline-flex; align-items:center; gap:8px; padding:6px 12px;
          border-radius:999px; background: rgba(11,92,255,.12);
          color:#cfe0ff; border:1px solid rgba(138,180,255,.25);
          font-weight:600; font-size:13px; cursor:pointer;
        }

        .psli-grid { display:grid; gap:18px; }
        .psli-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
        .psli-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        @media (max-width: 900px) { .psli-cols-3, .psli-cols-2 { grid-template-columns: 1fr; } }

        .psli-card { background: linear-gradient(180deg, var(--panel), var(--panel-2)); border:1px solid rgba(255,255,255,.06); border-radius:var(--card-radius); box-shadow:var(--shadow); padding:20px 18px; }
        .psli-card h3 { margin:0 0 8px; font-size:18px; }
        .psli-card p { margin:0; color:var(--muted); }

        .psli-kv { display:flex; gap:12px; align-items:flex-start; padding:14px 0; border-top:1px dashed rgba(255,255,255,.08); }
        .psli-kv:first-child { border-top:0; }
        .psli-k { flex:0 0 160px; color:#cfe0ff; font-weight:700; text-transform:uppercase; letter-spacing:.6px; font-size:12px; }
        .psli-v { flex:1; color:var(--text); }

        .psli-badges { display:flex; gap:8px; flex-wrap:wrap; }
        .psli-badge { display:inline-flex; align-items:center; gap:8px; padding:8px 12px; border-radius:12px; background:rgba(255,255,255,.04); border:1px solid rgba(255,255,255,.08); font-weight:600; color:var(--text); }

        .psli-section { margin:30px 0; }
        .psli-section h2 { font-size:22px; margin:0 0 8px; }
        .psli-muted { color:var(--muted); }

        .psli-headline { display:flex; align-items:center; gap:12px; margin:28px 0 10px; }
        .psli-rule { height:1px; background:linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,.2), rgba(255,255,255,0)); flex:1; }

        .psli-callout { border-left:3px solid var(--brand); background:rgba(11,92,255,.08); padding:14px 16px; border-radius:10px; }

        .psli-metrics { display:grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap:12px; margin-top:12px; }
        .psli-metric { text-align:center; padding:16px; border-radius:14px; background:rgba(255,255,255,.04); border:1px solid rgba(255,255,255,.08); }
        .psli-metric h4 { margin:0 0 4px; font-size:20px; }
        .psli-metric p { margin:0; color:var(--muted); font-size:14px; }
        @media (max-width: 1000px) { .psli-metrics { grid-template-columns: 1fr 1fr; } }
        @media (max-width: 700px) { .psli-metrics { grid-template-columns: 1fr; } }

        .psli-footer { margin:40px 0 20px; color:var(--muted); font-size:13px; text-align:center; }

        /* Dropdown menu */
        .psli-menu {
          position:absolute;
          background-color:#0f131a;
          min-width:260px;
          z-index:10;
          border-radius:10px;
          box-shadow: var(--shadow);
          border:1px solid rgba(255,255,255,.12);
          margin-top:8px;
        }
        .psli-menu a { color:var(--text); padding:12px; text-decoration:none; display:block; }
        .psli-menu a:hover { background-color: var(--brand-2); }

        @media print {
          .psli-header { display:none; }
          .psli-root { background:#fff; color:#111; }
          .psli-card { background:#fff; border-color:#ddd; box-shadow:none; }
          .psli-hero .psli-tag { background:#e9f1ff; color:#0b5cff; border-color:#c9ddff; }
        }
      `}</style>

      <div className="psli-root">
        {/* Page header (sticks under HomeHeader) */}
        <header className="psli-header">
          <div className="psli-container psli-nav">
            <a
              className="psli-logo"
              href="#top"
              aria-label="Charlee.ai — Proactive Severity & Litigation Intelligence"
            >
              <span className="psli-mark" aria-hidden="true">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path
                    d="M12 2l2.2 5.7L20 10l-5.8 2.3L12 18l-2.2-5.7L4 10l5.8-2.3L12 2z"
                    fill="white"
                    opacity=".9"
                  />
                </svg>
              </span>
              <span className="psli-word">Charlee.ai</span>
            </a>
            <div className="psli-cta">
              <a className="psli-btn ghost" href="#value">
                Value
              </a>
              <a className="psli-btn ghost" href="#financial-impact">
                Financial Impact
              </a>
              <a className="psli-btn primary" href="#product">
                Product
              </a>
            </div>
          </div>
        </header>

        <main className="psli-container" style={{ paddingTop: "70px" }}>
          <section className="psli-hero">
            {/* Dropdown trigger */}
            <span
              ref={tagRef}
              className="psli-tag"
              onClick={() => setMenuOpen((v) => !v)}
              aria-haspopup="true"
              aria-expanded={menuOpen}
              role="button"
            >
              Use Case 5 · Proactive Severity & Litigation Intelligence{" "}
              <span aria-hidden="true">▼</span>
            </span>

            {/* Dropdown menu (SEO-friendly anchors) */}
            <div
              ref={dropdownRef}
              className="psli-menu"
              style={{ display: menuOpen ? "block" : "none" }}
            >
              {/* Point these to your SPA routes (kept as <a> for crawlability) */}
              <a href="/usecase/large-loss-alerts">
                Use Case 1 · Large Loss Alerts
              </a>
              <a href="/usecase/early-severity-signal-detection">
                Use Case 2 · Early Severity Signal Detection
              </a>
              <a href="/usecase/reserve-adequacy-monitoring">
                Use Case 3 · Reserve Adequacy Monitoring (Incurred Below
                Prediction)
              </a>
              <a href="/usecase/high-severity-potential-claims">
                Use Case 4 · High Severity Potential Claims
              </a>
              <a href="/usecase/proactive-severity-litigation-intelligence">
                Use Case 5 · Proactive Severity & Litigation Intelligence
              </a>
              <a href="/usecase/intelligent-claims-document-summarization">
                Use Case 6 · Intelligent Claims Document Summarization
              </a>
            </div>

            <h1 style={{ fontWeight: "bold" }}>
              See Severity & Litigation Risk Coming <br />— And Act Before It
              Hits
            </h1>
            <p>
              In today’s environment of rising claim complexity—marked by early
              attorney involvement, nuclear verdicts, social inflation, and
              widening regional variance— litigation risk and severity can
              escalate quickly and unpredictably. Claims teams often lack the
              visibility to understand why outcomes vary across jurisdictions,
              claim types, or claimant profiles, resulting in inconsistent
              handling and avoidable cost spikes.
            </p>
            <br />
            <p className="psli-muted">
              <strong>4SeeCharlee</strong> empowers insurers to shift from
              reactive litigation response to proactive risk management. Using
              NLP-based forecasting and advanced pattern recognition, Charlee
              analyzes millions of historical claims to detect top severity and
              litigation drivers by region, line of business, and claimant
              profile. These insights help claims leaders predict where legal
              escalation is most likely and act early—whether through triage,
              negotiation, or training—before the cost curve bends upward.
            </p>
          </section>

          <section className="psli-grid psli-cols-3">
            <div className="psli-card">
              <h3 style={{ fontWeight: "bold" }}>Role</h3>
              <p>Claims Executives, Managers, Supervisors, Adjusters</p>
            </div>
            <div className="psli-card">
              <h3 style={{ fontWeight: "bold" }}>Job at Hand</h3>
              <p>Improve litigation strategy and reduce severity exposure</p>
            </div>
            <div className="psli-card">
              <h3 style={{ fontWeight: "bold" }}>Trigger</h3>
              <p>High variance in claim outcomes across regions</p>
            </div>
          </section>

          <section className="psli-section">
            <div className="psli-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>Opportunity</h2>
              <div className="psli-rule" />
            </div>
            <div className="psli-card">
              <p>
                Predictive visibility into litigation and severity patterns
                enables earlier, smarter interventions and tailored team
                training.
              </p>
            </div>
          </section>

          <section className="psli-grid psli-cols-2 psli-section">
            <div className="psli-card">
              <h3 style={{ fontWeight: "bold" }}>Before Charlee</h3>
              <p>
                Litigation insights were only available post-closure; teams
                operated reactively and lacked visibility into root drivers of
                legal escalation.
              </p>
            </div>
            <div className="psli-card" id="product">
              <h3 style={{ fontWeight: "bold" }}>With Charlee</h3>
              <p>
                AI surfaces top 5 litigation and severity risk patterns across
                regions, claim types, and claimant profiles—powering proactive
                strategy, segmentation, and training.
              </p>
            </div>
          </section>

          <section className="psli-section">
            <div className="psli-grid psli-cols-3">
              <div className="psli-card">
                <h3 style={{ fontWeight: "bold" }}>Product Used</h3>
                <div className="psli-badges">
                  <span className="psli-badge">🔎 4SeeCharlee</span>
                </div>
              </div>
              <div className="psli-card">
                <h3 style={{ fontWeight: "bold" }}>LOBs</h3>
                <div className="psli-badges">
                  <span className="psli-badge">All</span>
                </div>
              </div>
              <div className="psli-card" id="financial-impact">
                <h3 style={{ fontWeight: "bold" }}>Area</h3>
                <div className="psli-badges">
                  <span className="psli-badge">Claims</span>
                  <span className="psli-badge">Severity</span>
                  <span className="psli-badge">Litigation</span>
                </div>
              </div>
            </div>
          </section>

          <section className="psli-section">
            <div className="psli-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>
                Financial Impact
              </h2>
              <div className="psli-rule" />
            </div>
            <div className="psli-card">
              <p className="psli-muted">
                Delayed visibility into litigation and severity drivers leads
                to:
              </p>
              <ul style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                <li>
                  Higher legal spend, due to late involvement of defense counsel
                  and prolonged disputes
                </li>
                <li>
                  Inflated indemnity payments, from missed negotiation or early
                  resolution windows
                </li>
                <li>
                  Inefficient adjuster training, with no focus on exposure-based
                  risk trends
                </li>
              </ul>
              <div className="psli-callout" style={{ marginTop: 12 }}>
                <strong>With Charlee, insurers benefit from:</strong>
                <ul style={{ listStyleType: "disc", paddingLeft: "50px" }}>
                  <li>
                    $12K–$25K savings per litigated claim via faster resolution
                    and smarter allocation
                  </li>
                  <li>
                    17% reduction in regional litigation rates in pilot programs
                  </li>
                  <li>
                    Region-specific training insights to better prepare claims
                    teams
                  </li>
                  <li>
                    Improved alignment between claims and litigation strategy
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="psli-section">
            <div className="psli-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>Results</h2>
              <div className="psli-rule" />
            </div>
            <div className="psli-card">
              <div className="psli-metrics">
                <div
                  className="psli-metric"
                  aria-label="Regional litigation rate improvement"
                >
                  <h4>🚀 17%</h4>
                  <p>regional litigation rates down in pilot markets</p>
                </div>
                <div className="psli-metric" aria-label="Training tailoring">
                  <h4>✅</h4>
                  <p>adjuster training tailored to top exposure patterns</p>
                </div>
                <div className="psli-metric" aria-label="Customer quote">
                  <h4>💬</h4>
                  <p>
                    “For the first time, we’re managing risk with foresight.”
                  </p>
                </div>
                <div className="psli-metric" aria-label="Time to value">
                  <h4>⏱️ 3 weeks</h4>
                  <p>Actionable insights delivered</p>
                </div>
              </div>
            </div>
          </section>

          <section className="psli-section">
            <div className="psli-headline">
              <h2 style={{ margin: 0, fontWeight: "bold" }}>Why It Matters</h2>
              <div className="psli-rule" />
            </div>
            <div className="psli-card">
              <p>
                Predictive risk detection improves litigation outcomes, reduces
                costs, and strengthens claims team performance through smarter
                strategy and training.
              </p>
            </div>
          </section>

          <footer className="psli-footer">
            © {year} Charlee.ai — Use Case 5: Proactive Severity & Litigation
            Intelligence
          </footer>
        </main>
      </div>
    </div>
  );
};
